exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-nav{width:342px;height:56px;margin:0 auto;overflow:auto;white-space:nowrap}@media(min-width: 1160px){.user-nav{width:auto;height:68px;overflow:visible;margin:0;border-bottom:none;-webkit-box-shadow:none;box-shadow:none}}.user-nav a{position:relative;display:inline-block;vertical-align:bottom;padding:18px 0;margin-right:16px;color:#fff;font-size:15px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:20px;cursor:pointer}.user-nav a:last-child{margin-right:0}@media(min-width: 1160px){.user-nav a{padding-top:20px;padding-bottom:24px;margin-right:40px;font-size:15px;line-height:24px}}.user-nav a.active::after{position:absolute;left:0;right:0;bottom:0;content:\"\";height:4px;background-color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??postcss!./node_modules/sass-loader/dist/cjs.js!./src/routes/main/userprofile/navigation/style.scss
// module id = 1412
// module chunks = 58